import {
    LOAD_COUNTRIES,
    LOAD_STATES
} from '../../actions/geo';

export default function employees(state = {}, action) {
    switch (action.type) {
        case LOAD_COUNTRIES: 
            return Object.assign({}, state, action.payload);
        case LOAD_STATES: 
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/geo/index.js